export var getCardExpiryForUpdate=function getCardExpiryForUpdate(expiry){var value=expiry.replace(/\D/g,"");//take out all but numbers
value=value.substring(0,4);//take out extra characters
if(value.length>2){value=value.substring(0,2)+"/"+value.substring(2,4);}return value;};